'use strict';

// Breakpoints (keep this in sync with _custom-bootstrap-settings.scss)
const breakpointSm = 576;
const breakpointMd = 768;
const breakpointLg = 992;
const breakpointXl = 1200;

const bps = [];
bps['sm'] = breakpointSm;
bps['md'] = breakpointMd;
bps['lg'] = breakpointLg;
bps['xl'] = breakpointXl;

export const breakpoints = bps;